import { render } from "./CategoriesTable.vue?vue&type=template&id=ba711fda&ts=true"
import script from "./CategoriesTable.vue?vue&type=script&lang=ts"
export * from "./CategoriesTable.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Bohdan\\telesim_test\\telesim-admin-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__